import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

// Componente back funciona secillamente llamado al componente desde donde quieres que este.
// Si no añades el parametro @direction en la llamada del componente como un parametro @Input directamente al 
// pulsarlo te llevara a la anterior pagina en la que se ha estado (Ejemplo: <tech-back></tech-back>). 
// Para forzar una redireccion a cualquier pagina añadelo como parametro @Input con nombre 'direction'. 
// (Ejemplo: <tech-back [direction]="'/financialplanning'"></tech-back>)

@Component({
  selector: 'tech-back',
  templateUrl: './tech-back.component.html',
  styleUrls: ['./tech-back.component.scss']
})

export class TechBackComponent implements OnInit {
  @Input () direction: string;

  constructor(
    private _location: Location,
    private router: Router,
    ) { }

  ngOnInit(): void {
  }

  public goBack(){
    if(this.direction == undefined)
      this._location.back();
    else
      this.router.navigate([this.direction]);
  }
}
